import { useState } from "react";
import { useTranslation } from "react-i18next";
import OtpInput from "@components/account/OtpInput";

interface OtpInputFormProps {
  setErrorMessage: (message: string) => void;
  mobileFormId: string;
  otpFormId: string;
  purpose: string;
}

export default function OtpSubForm({
  setErrorMessage,
  mobileFormId,
  otpFormId,
  purpose,
}: OtpInputFormProps) {
  const [mobile, setMobile] = useState("");
  const { t } = useTranslation();

  return (
    <>
      <div>
        <label
          htmlFor={mobileFormId}
          className="block text-sm font-medium text-gray-700"
        >
          {t("account.common.mobile")}
        </label>
        <div className="mt-1">
          <input
            id={mobileFormId}
            name={mobileFormId}
            type={mobileFormId}
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            autoComplete={mobileFormId}
            pattern={"^[0-9]{11}$"}
            onInvalid={(e) =>
              (e.target as HTMLSelectElement).setCustomValidity(
                t("account.tooltip.mobilePattern")
              )
            }
            onInput={(e) =>
              (e.target as HTMLSelectElement).setCustomValidity("")
            }
            required
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm"
          />
        </div>
      </div>

      <div>
        <label
          htmlFor={otpFormId}
          className="block text-sm font-medium text-gray-700"
        >
          {t("account.common.otp")}
        </label>

        <div className="mt-1">
          <OtpInput
            setErrorMessage={setErrorMessage}
            otpFormId={otpFormId}
            mobile={mobile}
            purpose={purpose}
          />
        </div>
      </div>
    </>
  );
}
